import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { parsePermissions, PrivilegeMap } from "helpers/privileges/utils";
import { jwtDecode } from "jwt-decode";
import { useAuth0 } from "@auth0/auth0-react";

interface PrivilegeContextType {
  privileges: PrivilegeMap;
  hasActivePlan: boolean;
}

const PrivilegeContext = createContext<PrivilegeContextType>({
  privileges: {},
  hasActivePlan: false,
});

export const usePrivilege = () => useContext(PrivilegeContext);

export const PrivilegeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const hasActivePlan = true;
  const [privileges, setPrivileges] = useState<PrivilegeMap>({});

  useEffect(() => {
    const fetchPrivileges = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        const decodedToken = jwtDecode<any>(accessToken);
        setPrivileges(parsePermissions(decodedToken.permissions ?? []));
      } catch {
        setPrivileges({});
      }
    };

    fetchPrivileges();
  }, [getAccessTokenSilently, isAuthenticated]);

  const contextValue = useMemo(
    () => ({ privileges, hasActivePlan }),
    [privileges, hasActivePlan]
  );

  return (
    <PrivilegeContext.Provider value={contextValue}>
      {children}
    </PrivilegeContext.Provider>
  );
};
